import * as PJP from 'payterra-js-pay';

import axios from 'lib/utils/axios';
import validate from 'lib/utils/validationRules';

// import logrocket from '@/services/logrocket';

import checkoutError from 'api/requests/checkout/checkoutError';

const jsPayInstance = new PJP.PayTerraJsPay();

export const getPayterraPaymentData = async(payload, paymentId) => {
  try {
    const data = await jsPayInstance.transactionIdRequest(payload);

    if (validate.isObjectWithFields(data, ['transaction_id', 'card_token'])) {
      return {
        paymentToken: data.transaction_id,
        cardToken: data.card_token,
      };
    }

    await checkoutError(axios, {
      message: {
        ...data,
      },
      paymentId,
    });
  } catch (error) {
    console.error(error);
    // logrocket(error);
  }

  throw new Error();
};

export default jsPayInstance;
